import React from "react"
import "./footerLinks.css"

const linkLabels = {
  github: "GitHub",
  twitter: "Twitter",
  stackoverflow: "Stack Overflow",
  blunk: "Blunk",
  linkedin: "LinkedIn",
  email: "Email",
  toptal: "Toptal",
}

const FooterLinks = ({ links }) => (
  <footer className="footer-links" aria-label="More ways to connect">
    <span className="footer-links__label">Find me on</span>
    <span className="footer-links__items">
      {links.map((link, index) => (
        <React.Fragment key={link.name}>
          {index > 0 && <span aria-hidden="true"> · </span>}
          <a
            href={link.url}
            target={link.url.startsWith("http") ? "_blank" : undefined}
            rel={
              link.url.startsWith("http") ? "noopener noreferrer" : undefined
            }
          >
            {linkLabels[link.name] || link.name}
          </a>
        </React.Fragment>
      ))}
    </span>
  </footer>
)

export default FooterLinks
